import request from './request';

export default {
  getList: ({ locationId }) => request.easytip({
    method: 'get',
    url: `/v2/restaurants/${locationId}/owners`,
  }),
  create: ({ locationId, ...data }) => request.easytip({
    method: 'post',
    url: `/v2/restaurants/${locationId}/owners/registration`,
    data,
  }),
  update: ({ locationId, id, ...data }) => request.easytip({
    method: 'put',
    url: `/v2/restaurants/${locationId}/owners/${id}`,
    data,
  }),
  deactivate: ({ locationId, id }) => request.easytip({
    method: 'delete',
    url: `/v2/restaurants/${locationId}/owners/${id}`,
  }),
  sendRegistrationMessage: ({ locationId, id }) => request.easytip({
    method: 'post',
    url: `/v2/restaurants/${locationId}/owners/${id}/resendInvitation`,
  }),
  getRegistrationMessage: ({ locationId, id }) => request.easytip({
    method: 'get',
    url: `/v2/restaurants/${locationId}/owners/${id}/resendInvitation`,
  }),
};
